import React from "react";
import { FileText, Layers, Calendar, Sparkles, PenTool, Magnet, Route, LayoutTemplate, Globe, BookOpen, Video, Image } from "lucide-react";
import { Section, Eyebrow, Reveal } from "./shared";
import { TOOLKIT } from "../../lib/site";

const icons = [FileText, Layers, Calendar, Sparkles, PenTool, Magnet, Route, LayoutTemplate, Globe, BookOpen, Video, Image];
// bento spans (index -> extra classes)
const spans = [
  "sm:col-span-2", "", "", "sm:row-span-2", "", "sm:col-span-2", "", "", "sm:col-span-2", "", "", "",
];
const bgs = ["#0B31EB", "#FFFFFF", "#FFFFFF", "#FFCB52", "#FFFFFF", "#E90019", "#FFFFFF", "#FFFFFF", "#111111", "#FFFFFF", "#FFFFFF", "#FFFFFF"];

export default function Toolkit() {
  return (
    <Section id="toolkit" bg="bg-brand-palegreen">
      <Reveal className="max-w-3xl">
        <Eyebrow color="#4CAF48">Implementation Toolkit</Eyebrow>
        <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl leading-[0.98] mt-5">
          You Won&rsquo;t Have to Build Everything From Scratch
        </h2>
        <p className="text-base sm:text-lg text-brand-ink/75 mt-5">
          Knowing what to do is important. Having templates, frameworks, and practical resources makes implementation faster.
        </p>
      </Reveal>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 auto-rows-[minmax(120px,auto)] gap-4 sm:gap-5 mt-12">
        {TOOLKIT.map((t, i) => {
          const Icon = icons[i];
          const bg = bgs[i];
          const light = bg === "#FFFFFF" || bg === "#FFCB52";
          return (
            <Reveal key={t} delay={(i % 3) * 0.05} className={spans[i]}>
              <div className="h-full rounded-[22px] border-2 border-brand-black p-5 sm:p-6 flex flex-col justify-between transition-transform duration-300 hover:-translate-y-1"
                style={{ background: bg, color: light ? "#242424" : "#F2F1E5", boxShadow: "6px 8px 0 #111111" }}>
                <span className="h-10 w-10 rounded-xl flex items-center justify-center border-2 border-brand-black/20"
                  style={{ background: light ? "#F2F1E5" : "rgba(255,255,255,0.15)" }}>
                  <Icon size={18} style={{ color: light ? "#111111" : "#F2F1E5" }} />
                </span>
                <p className="font-bold text-base sm:text-lg mt-4 leading-tight">{t}</p>
              </div>
            </Reveal>
          );
        })}
      </div>
    </Section>
  );
}
